// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"cff62d15","226":"cff62d15","466":"cff62d15","753":"cff62d15","773":"cff62d15","862":"cff62d15","896":"cff62d15","984":"cff62d15"}[chunkId] + ".chunk.css";
};